import { InfoCircleOutlined } from '@ant-design/icons';

/**
 * Henüz bir grup seçilmediğinde gösterilen uyarı.
 */
function SelectGroupPrompt() {
  return (
    <div
      style={{
        height: '200px',
        border: '2px dashed #d9d9d9',
        borderRadius: '6px',
        color: '#8c8c8c',
        gap: 8,
      }}
      className="gx-w-100 gx-align-items-center gx-justify-content-center gx-d-flex gx-flex-column"
    >
      <InfoCircleOutlined style={{ fontSize: 24 }} />
      Listelemek için bir grup seçiniz.
    </div>
  );
}

export default SelectGroupPrompt;
